/* 6FT Club product page behaviour (sections/main-product.liquid,
   sections/pdp-cross-sell.liquid). Adds to cart only through
   window.SixFtCart (assets/theme.js); falls back to the native
   Shopify form post when that helper is missing. */
(function () {
  'use strict';
  if (window.SixFtPDP) return;

  var DESKTOP_MIN = 901;
  var THUMB_GAP = 12;
  var MIN_THUMB = 56;
  var TOAST_MS = 2400;
  var SWIPE_STRIP_THRESHOLD = 30; // px of horizontal movement before a strip counts as a swipe
  var TRACK_OFFSET = 1; // one cloned slide prepended for the loop illusion (see buildTrack)
  var canHover = window.matchMedia ? window.matchMedia('(hover: hover)').matches : true;

  function qs(root, sel) { return root.querySelector(sel); }
  function qsa(root, sel) { return Array.prototype.slice.call(root.querySelectorAll(sel)); }
  function hasCart() { return !!(window.SixFtCart && typeof window.SixFtCart.addVariant === 'function'); }
  function openCart() { if (window.SixFtCart && typeof window.SixFtCart.open === 'function') window.SixFtCart.open(); }
  function errorText(err, fallback) {
    if (err && typeof err.description === 'string' && err.description) return err.description;
    if (err && typeof err.message === 'string' && err.message) return err.message;
    return fallback;
  }

  /* ---------------- Gallery, zoom, share ---------------- */
  function initGallery(root) {
    var grid = qs(root, '.pdp-grid');
    var mainWrap = qs(root, '[data-pdp-main]');
    var mainImg = qs(root, '[data-pdp-main-img]');
    var thumbs = qsa(root, '.pdp-thumb');
    var stickyImg = qs(root, '[data-pdp-sticky-img]');
    // Dots and arrows are rendered once and shown per device by CSS, so there is
    // one gallery and one code path whatever the section settings say. Which of
    // them the shopper can see is never asked here — clicking a hidden control
    // is not reachable, and the handlers stay identical on both breakpoints.
    var dots = qsa(root, '[data-pdp-dot]');
    var prevBtn = qs(root, '[data-pdp-prev]');
    var nextBtn = qs(root, '[data-pdp-next]');
    // The lift badge only makes sense pinned to the product's primary photo —
    // on every other slide it just reads as clutter (see syncControls below).
    var liftBadge = qs(root, '[data-pdp-lift-badge]');

    // The mobile stage is a native scroll-snap track (see buildTrack): the browser
    // owns the horizontal gesture, so a diagonal swipe locks to one axis instead
    // of dragging the page. `fromTrack` means the user scrolled it, so we update
    // the thumbnails but must not scroll the track back underneath their finger.
    var track = buildTrack(mainWrap, thumbs);
    var trackBusy = false;
    var trackBusyTimer = null;
    var lastTrackIdx = -1;

    function activeIndex() {
      for (var i = 0; i < thumbs.length; i++) {
        if (thumbs[i].classList.contains('active')) return i;
      }
      return 0;
    }

    // index here is always a REAL index (0..thumbs.length-1); TRACK_OFFSET
    // accounts for the cloned slide buildTrack prepends for the loop illusion.
    function scrollTrackTo(index, smooth) {
      if (!track || index < 0) return;
      var w = track.clientWidth;
      if (!w) return;
      var left = (index + TRACK_OFFSET) * w;
      if (Math.abs(track.scrollLeft - left) < 2) return;
      trackBusy = true;
      clearTimeout(trackBusyTimer);
      trackBusyTimer = setTimeout(function () { trackBusy = false; }, smooth ? 480 : 120);
      try { track.scrollTo({ left: left, behavior: smooth ? 'smooth' : 'auto' }); }
      catch (e) { track.scrollLeft = left; }
    }

    function centreThumb(thumb) {
      var rail = thumb && thumb.parentElement;
      if (!rail || rail.scrollWidth <= rail.clientWidth) return;
      var left = thumb.offsetLeft - (rail.clientWidth - thumb.offsetWidth) / 2;
      try { rail.scrollTo({ left: left, behavior: 'smooth' }); }
      catch (e) { rail.scrollLeft = left; }
    }

    function syncControls(idx) {
      if (typeof idx !== 'number' || idx < 0) idx = activeIndex();
      dots.forEach(function (d, i) {
        var on = i === idx;
        d.classList.toggle('active', on);
        if (on) d.setAttribute('aria-current', 'true');
        else d.removeAttribute('aria-current');
      });
      // The gallery loops in both directions (see goTo/buildTrack), so there's
      // always a next/previous image — the arrows are never end-disabled.
      if (prevBtn) prevBtn.disabled = false;
      if (nextBtn) nextBtn.disabled = false;
      // Sticks to the primary photo (index 0) only — hidden on every other
      // slide, and reappears automatically on scrolling/clicking back to it.
      if (liftBadge) liftBadge.classList.toggle('is-hidden', idx !== 0);
    }

    // Move the gallery from a control. Wraps in both directions — "next" past
    // the last photo goes to the first, "previous" before the first goes to
    // the last — so an arrow, a dot, or a swipe-strip swipe always has
    // somewhere to go. Leaving a zoomed-in stage on a photo the shopper just
    // navigated away from reads as a stuck image, so drop the zoom too.
    function goTo(index) {
      var count = thumbs.length;
      if (count === 0) return;
      index = ((index % count) + count) % count;
      if (mainWrap && mainWrap.classList.contains('zoomed')) {
        mainWrap.classList.remove('zoomed');
        if (mainImg) mainImg.style.transformOrigin = '';
      }
      setActive(thumbs[index], false, true);
      centreThumb(thumbs[index]);
    }

    function setActive(thumb, fromTrack, smooth) {
      if (!thumb || !mainImg || !thumb.dataset.full) return;
      if (!thumb.classList.contains('active')) {
        if (thumb.dataset.srcset) mainImg.setAttribute('srcset', thumb.dataset.srcset);
        else mainImg.removeAttribute('srcset');
        mainImg.src = thumb.dataset.full;
        mainImg.alt = thumb.dataset.alt || '';
        thumbs.forEach(function (t) {
          var on = t === thumb;
          t.classList.toggle('active', on);
          if (on) t.setAttribute('aria-current', 'true');
          else t.removeAttribute('aria-current');
        });
        if (stickyImg && thumb.dataset.thumb) stickyImg.src = thumb.dataset.thumb;
      }
      syncControls(thumbs.indexOf(thumb));
      if (track && !fromTrack) scrollTrackTo(thumbs.indexOf(thumb), smooth);
    }

    if (track) {
      lastTrackIdx = activeIndex();
      // Jump instantly (no animation, no transition flash) past the leading
      // clone slide to the real starting image — runs before the shopper can
      // see anything, so the offset introduced by the loop clones is invisible
      // regardless of which image starts active.
      scrollTrackTo(lastTrackIdx, false);

      var trackRaf = null;
      var settleTimer = null;
      var realCount = thumbs.length;

      // Once a swipe settles on one of the two clone slides (past either real
      // end), silently jump scrollLeft to the matching real slide — no
      // animation, so it's invisible since the clone is pixel-identical to
      // the real slide it stands in for. This is what makes native
      // scroll-snap swiping feel like an infinite loop without a JS-driven
      // carousel replacing the browser's own touch handling.
      function settleOnRealSlide() {
        var w = track.clientWidth;
        if (!w) return;
        var rawIdx = Math.round(track.scrollLeft / w);
        if (rawIdx === 0) {
          track.scrollLeft = (realCount - 1 + TRACK_OFFSET) * w;
        } else if (rawIdx === realCount + 1) {
          track.scrollLeft = (0 + TRACK_OFFSET) * w;
        }
      }

      track.addEventListener('scroll', function () {
        if (trackRaf) return;
        trackRaf = requestAnimationFrame(function () {
          trackRaf = null;
          if (trackBusy) return;
          var w = track.clientWidth;
          if (!w) return;
          var rawIdx = Math.round(track.scrollLeft / w);
          var realIdx = rawIdx - TRACK_OFFSET;
          if (realIdx < 0) realIdx = realCount - 1;
          else if (realIdx > realCount - 1) realIdx = 0;
          if (realIdx === lastTrackIdx) return;
          lastTrackIdx = realIdx;
          setActive(thumbs[realIdx], true);
          centreThumb(thumbs[realIdx]);
        });
        clearTimeout(settleTimer);
        settleTimer = setTimeout(settleOnRealSlide, 120);
      }, { passive: true });
    }

    // Swipe-catch strips beside the image (see main-product.css / .pdp-swipe-strip):
    // extend the swipeable zone out to the screen edges without touching the
    // image's own native scroll-snap track. A strip only exists when there is
    // more than one media item (same guard buildTrack uses), and reuses the
    // exact same goTo()/activeIndex() the arrow buttons already call, so it
    // stays in sync with dots, thumbnails and the sticky bar automatically —
    // including the wraparound goTo() now does at either end.
    function initSwipeStrips() {
      var strips = qsa(root, '[data-pdp-swipe-strip]');
      if (!track || !strips.length) return;
      strips.forEach(function (strip) {
        var startX = null;
        var startY = null;
        var tracking = false;
        strip.addEventListener('touchstart', function (e) {
          if (e.touches.length !== 1) return;
          startX = e.touches[0].clientX;
          startY = e.touches[0].clientY;
          tracking = true;
        }, { passive: true });
        strip.addEventListener('touchmove', function (e) {
          if (!tracking || e.touches.length !== 1) return;
          var dx = e.touches[0].clientX - startX;
          var dy = e.touches[0].clientY - startY;
          // A mostly-vertical drag isn't a gallery swipe — let it fall through
          // to the page (touch-action: pan-y on the strip already allows this).
          if (Math.abs(dy) > Math.abs(dx)) tracking = false;
        }, { passive: true });
        strip.addEventListener('touchend', function (e) {
          if (!tracking || startX === null) { tracking = false; startX = null; startY = null; return; }
          var touch = e.changedTouches && e.changedTouches[0];
          var endX = touch ? touch.clientX : startX;
          var dx = endX - startX;
          tracking = false;
          startX = null;
          startY = null;
          if (Math.abs(dx) < SWIPE_STRIP_THRESHOLD) return;
          goTo(activeIndex() + (dx < 0 ? 1 : -1));
        }, { passive: true });
        strip.addEventListener('touchcancel', function () {
          tracking = false;
          startX = null;
          startY = null;
        }, { passive: true });
      });
    }
    initSwipeStrips();

    thumbs.forEach(function (t) {
      if (canHover) t.addEventListener('mouseenter', function () { setActive(t); });
      t.addEventListener('click', function () { setActive(t, false, true); });
    });

    dots.forEach(function (d, i) {
      d.addEventListener('click', function () { goTo(i); });
    });
    if (prevBtn) prevBtn.addEventListener('click', function () { goTo(activeIndex() - 1); });
    if (nextBtn) nextBtn.addEventListener('click', function () { goTo(activeIndex() + 1); });
    syncControls();

    /* Warm the browser cache for the rest of the gallery. Only the small
       thumbnail of each photo has been downloaded at this point, so the
       FIRST hover or tap on a thumbnail otherwise has to start a fresh
       network fetch for the full-size file — that is the delay that reads
       as "the main image loads late". Deferred to idle time so it never
       competes with the images and scripts the page needs first. */
    function warmGallery() {
      thumbs.forEach(function (t) {
        if (!t.dataset.full) return;
        var img = new Image();
        if (t.dataset.srcset) img.srcset = t.dataset.srcset;
        img.src = t.dataset.full;
      });
    }
    if ('requestIdleCallback' in window) window.requestIdleCallback(warmGallery, { timeout: 2000 });
    else setTimeout(warmGallery, 1200);

    if (mainWrap && mainImg && mainWrap.classList.contains('is-zoomable') && canHover) {
      mainWrap.addEventListener('click', function (e) {
        if (e.target.closest('button')) return;
        mainWrap.classList.toggle('zoomed');
        if (!mainWrap.classList.contains('zoomed')) mainImg.style.transformOrigin = '';
      });
      mainWrap.addEventListener('mousemove', function (e) {
        if (!mainWrap.classList.contains('zoomed')) return;
        var rect = mainWrap.getBoundingClientRect();
        var x = ((e.clientX - rect.left) / rect.width) * 100;
        var y = ((e.clientY - rect.top) / rect.height) * 100;
        mainImg.style.transformOrigin = x + '% ' + y + '%';
      });
      mainWrap.addEventListener('mouseleave', function () {
        mainWrap.classList.remove('zoomed');
        mainImg.style.transformOrigin = '';
      });
    } else if (mainWrap) {
      mainWrap.classList.remove('is-zoomable');
    }

    initShare(root, mainWrap);

    // Size the square thumbnails so the rail spans the main image height (desktop only).
    function syncThumbSize() {
      if (!grid || !mainWrap || thumbs.length < 2) return;
      // With the desktop rail switched off, the 96px column must go too or the
      // image sits inset from a gap nothing occupies.
      if (window.innerWidth < DESKTOP_MIN || !root.classList.contains('g-d-thumbs')) {
        grid.style.gridTemplateColumns = '';
        thumbs.forEach(function (t) { t.style.width = ''; t.style.height = ''; });
        return;
      }
      var imgH = mainWrap.getBoundingClientRect().height;
      if (!imgH) return;
      var size = Math.max(MIN_THUMB, Math.floor((imgH - (thumbs.length - 1) * THUMB_GAP) / thumbs.length));
      grid.style.gridTemplateColumns = size + 'px minmax(0,1fr) minmax(0,1fr)';
      thumbs.forEach(function (t) { t.style.width = size + 'px'; t.style.height = size + 'px'; });
    }
    syncThumbSize();
    var resizeTimer = null;
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function () {
        syncThumbSize();
        // A rotation changes the slide width, so the snap offset has to be redone.
        if (track) { lastTrackIdx = activeIndex(); scrollTrackTo(lastTrackIdx, false); }
      }, 100);
    });

    return {
      showMedia: function (mediaId) {
        if (!mediaId) return;
        var match = thumbs.filter(function (t) { return t.dataset.mediaId === String(mediaId); })[0];
        if (match) setActive(match);
      }
    };
  }

  // Build the mobile stage as a real horizontal scroll container, one slide per
  // thumbnail — PLUS one cloned slide at each end (last-clone first, first-clone
  // last) so a swipe past either real end lands on a clone instead of a hard
  // stop. Once that swipe settles, initGallery's scroll listener jumps the
  // scroll position silently to the matching real slide — invisible, since the
  // clone is pixel-identical, and it's what makes swiping loop infinitely
  // without replacing the browser's native scroll-snap touch handling with a
  // JS-driven carousel.
  //
  // Native scroll-snap is also what makes an imperfect swipe behave in the
  // first place: iOS locks the gesture to a single axis, so a diagonal drag
  // either moves the gallery or scrolls the page, never both. A prior
  // pointerdown/up handler ran under `touch-action: pan-y`, which handed every
  // gesture with a vertical component to the page — at the top of a PDP that
  // bounced into pull-to-refresh and reloaded the page mid-swipe.
  function buildTrack(mainWrap, thumbs) {
    if (!mainWrap || thumbs.length < 2) return null;
    var existing = mainWrap.querySelector('[data-pdp-track]');
    if (existing) return existing;

    var activeIdx = 0;
    thumbs.forEach(function (t, i) { if (t.classList.contains('active')) activeIdx = i; });

    var track = document.createElement('div');
    track.className = 'pdp-track';
    track.setAttribute('data-pdp-track', '');

    function makeSlide(t, eager) {
      var slide = document.createElement('div');
      slide.className = 'pdp-slide';
      var img = document.createElement('img');
      if (t.dataset.srcset) img.setAttribute('srcset', t.dataset.srcset);
      img.setAttribute('sizes', 'calc(100vw - 44px)');
      img.src = t.dataset.full;
      img.alt = t.dataset.alt || '';
      img.decoding = 'async';
      img.draggable = false;
      if (eager) {
        img.loading = 'eager';
        img.setAttribute('fetchpriority', 'high');
      } else {
        img.loading = 'lazy';
      }
      slide.appendChild(img);
      return slide;
    }

    track.appendChild(makeSlide(thumbs[thumbs.length - 1], false)); // leading clone of the last slide
    thumbs.forEach(function (t, i) {
      track.appendChild(makeSlide(t, i === activeIdx));
    });
    track.appendChild(makeSlide(thumbs[0], false)); // trailing clone of the first slide

    mainWrap.insertBefore(track, mainWrap.firstChild);
    // Only a stage that actually has slides hides its single <img>; a
    // one-image product keeps it, or the mobile stage renders empty.
    mainWrap.classList.add('has-track');
    return track;
  }

  function initShare(root, mainWrap) {
    var btn = qs(root, '[data-pdp-share]');
    var toast = qs(root, '[data-pdp-toast]');
    if (!btn) return;
    var timer = null;
    var copiedText = root.dataset.shareCopied || 'Link copied';

    function showToast(msg) {
      if (!toast) return;
      toast.textContent = msg;
      requestAnimationFrame(function () { toast.classList.add('show'); });
      clearTimeout(timer);
      timer = setTimeout(function () { toast.classList.remove('show'); }, TOAST_MS);
    }
    function legacyCopy(url) {
      try {
        var temp = document.createElement('textarea');
        temp.value = url;
        temp.setAttribute('readonly', '');
        temp.style.position = 'fixed';
        temp.style.opacity = '0';
        document.body.appendChild(temp);
        temp.select();
        var ok = document.execCommand('copy');
        document.body.removeChild(temp);
        showToast(ok ? copiedText : url);
      } catch (err) {
        showToast(url);
      }
    }
    function copyLink(url) {
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(url).then(function () { showToast(copiedText); }, function () { legacyCopy(url); });
      } else {
        legacyCopy(url);
      }
    }

    btn.addEventListener('click', function (e) {
      e.stopPropagation();
      var url = window.location.href;
      if (navigator.share) {
        navigator.share({ title: root.dataset.shareTitle || document.title, url: url }).catch(function (err) {
          if (err && err.name === 'AbortError') return;
          copyLink(url);
        });
      } else {
        copyLink(url);
      }
    });
    if (mainWrap) {
      qsa(mainWrap, '.pdp-circle-btn').forEach(function (b) {
        b.addEventListener('click', function (e) { e.stopPropagation(); });
      });
    }
  }

  /* ---------------- Variant / size selection ---------------- */
  function initVariants(root, gallery) {
    var dataEl = qs(root, '[data-pdp-variants]');
    var variants = [];
    try { variants = JSON.parse(dataEl ? dataEl.textContent : '[]'); } catch (err) { variants = []; }

    var form = qs(root, 'form[data-pdp-form]');
    var idInput = qs(root, 'input[data-pdp-id]');
    var atc = qs(root, '[data-pdp-atc]');
    var dynamic = qs(root, '[data-pdp-dynamic]');
    var help = qs(root, '[data-pdp-size-help]');
    var errorEl = qs(root, '[data-pdp-error]');
    var sizeBtns = qsa(root, '.pdp-size-btn');
    var unitBtns = qsa(root, '.unit-toggle button');
    var priceEl = qs(root, '[data-pdp-price]');
    var compareEl = qs(root, '[data-pdp-compare]');
    var installInput = qs(root, 'form[data-pdp-installments] input[name="id"]');
    var stockRow = qs(root, '[data-pdp-stock]');
    var stockText = qs(root, '[data-pdp-stock-text]');
    var stockDot = qs(root, '[data-pdp-stock-dot]');
    var stickySelect = qs(root, '[data-pdp-sticky-size]');
    var stickyAdd = qs(root, '[data-pdp-sticky-add]');
    var stickyPrice = qs(root, '[data-pdp-sticky-price]');
    var labels = {
      select: root.dataset.labelSelect || 'Select your size',
      add: root.dataset.labelAdd || 'Add to cart',
      soldout: root.dataset.labelSoldout || 'Sold out',
      error: root.dataset.labelError || 'Could not add this item to your cart.'
    };

    function findVariant(id) {
      return variants.filter(function (v) { return String(v.id) === String(id); })[0] || null;
    }
    var selected = idInput ? findVariant(idInput.value) : null;

    // Reads the size a .pdp-size-btn actually shows (e.g. "10", "US 10"),
    // regardless of unit toggling, so the default-size logic below matches
    // what the shopper sees rather than raw Shopify option text.
    function sizeNumber(btn) {
      var raw = (btn.dataset.us || '') + ' ' + (btn.dataset.eu || '');
      var m = raw.replace(/US/gi, '').match(/[\d.]+/);
      return m ? parseFloat(m[0]) : NaN;
    }

    // Default size to land on when the page loads with nothing selected via
    // ?variant=: a product with only two sizes on offer starts on the
    // smaller one; otherwise size 10 is preselected (when it exists and is
    // in stock) so Add to cart is already active. Anything else is left
    // unselected, same as before.
    function pickDefaultVariant() {
      if (!sizeBtns.length) return null;
      if (sizeBtns.length === 2) {
        var bySize = sizeBtns.slice().sort(function (a, b) { return sizeNumber(a) - sizeNumber(b); });
        var smallest = bySize.filter(function (b) { return !b.disabled; })[0] || bySize[0];
        return findVariant(smallest.dataset.variantId);
      }
      var tenBtn = sizeBtns.filter(function (b) { return !b.disabled && sizeNumber(b) === 10; })[0];
      return tenBtn ? findVariant(tenBtn.dataset.variantId) : null;
    }

    function setError(msg) {
      if (!errorEl) return;
      errorEl.textContent = msg || '';
      errorEl.hidden = !msg;
    }

    function renderStock(v) {
      if (!stockRow || !stockText) return;
      var qty = v ? v.stock : parseInt(stockRow.dataset.total || '0', 10);
      var threshold = parseInt(stockRow.dataset.threshold || '0', 10);
      var critical = threshold > 0 && qty > 0 && qty <= threshold;
      var ships = stockRow.dataset.ships || '';
      var text = '';
      if (qty > 0) {
        var label = critical
          ? (stockRow.dataset.lowText || '').replace('[count]', qty)
          : (stockRow.dataset.inText || '');
        text = label + (ships ? ' · ' : '');
      }
      text += ships;
      stockText.textContent = text;
      stockRow.hidden = !text;
      if (stockDot) {
        stockDot.hidden = !!(v && !v.available);
        stockDot.classList.toggle('is-critical', critical);
      }
    }

    function updateUrl(v) {
      if (!v || !window.history || !window.history.replaceState) return;
      try {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', v.id);
        window.history.replaceState(window.history.state, '', url.toString());
      } catch (err) { /* URL API unavailable: keep current URL */ }
    }

    function select(v, opts) {
      selected = v;
      var ready = !!(v && v.available);
      if (idInput) idInput.value = v ? v.id : '';
      sizeBtns.forEach(function (b) {
        var on = !!v && b.dataset.variantId === String(v.id);
        b.classList.toggle('selected', on);
        b.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
      if (stickySelect) stickySelect.value = v ? String(v.id) : '';
      if (atc) {
        atc.disabled = !ready;
        atc.textContent = !v ? labels.select : (v.available ? labels.add : labels.soldout);
      }
      if (stickyAdd) {
        stickyAdd.disabled = !ready;
        stickyAdd.textContent = v && !v.available ? labels.soldout : labels.add;
      }
      if (help) help.hidden = !!v;
      if (dynamic) dynamic.hidden = !ready;
      setError('');
      renderStock(v);
      if (!v) return;
      if (priceEl) priceEl.textContent = v.price;
      if (stickyPrice) stickyPrice.textContent = v.price;
      if (compareEl) {
        compareEl.textContent = v.compare || '';
        compareEl.hidden = !v.compare;
      }
      if (installInput) {
        installInput.value = v.id;
        installInput.dispatchEvent(new Event('change', { bubbles: true }));
      }
      if (gallery && v.media) gallery.showMedia(v.media);
      if (!opts || opts.updateUrl !== false) updateUrl(v);
    }

    sizeBtns.forEach(function (b) {
      b.addEventListener('click', function () {
        if (b.disabled) return;
        select(findVariant(b.dataset.variantId));
      });
    });
    if (stickySelect) {
      stickySelect.addEventListener('change', function () {
        var v = findVariant(stickySelect.value);
        if (v) select(v);
      });
    }

    unitBtns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var unit = btn.dataset.unit;
        unitBtns.forEach(function (b) {
          var on = b === btn;
          b.classList.toggle('active', on);
          b.setAttribute('aria-pressed', on ? 'true' : 'false');
        });
        sizeBtns.forEach(function (b) {
          var us = b.dataset.us || '';
          var eu = b.dataset.eu || '';
          if (!eu) return;
          var primary = qs(b, '.primary');
          var secondary = qs(b, '.secondary');
          if (primary) primary.textContent = unit === 'EU' ? eu : us;
          if (secondary) secondary.textContent = unit === 'EU' ? us : eu;
        });
      });
    });

    function addSelected(btn) {
      if (!selected || !selected.available) return;
      if (!hasCart()) {
        if (form) form.submit();
        return;
      }
      btn.disabled = true;
      btn.setAttribute('aria-busy', 'true');
      setError('');
      window.SixFtCart.addVariant(selected.id, 1)
        .then(function () { openCart(); })
        .catch(function (err) { setError(errorText(err, labels.error)); })
        .then(function () {
          btn.removeAttribute('aria-busy');
          btn.disabled = !(selected && selected.available);
        });
    }

    if (form) {
      form.addEventListener('submit', function (e) {
        if (!hasCart()) return;
        e.preventDefault();
        if (atc) addSelected(atc);
      });
    }
    if (stickyAdd) stickyAdd.addEventListener('click', function () { addSelected(stickyAdd); });

    // Initial state from the server render (?variant=), or, failing that,
    // a sensible default size so the shopper isn't forced to pick before
    // Add to cart becomes usable.
    if (!selected) selected = pickDefaultVariant();
    select(selected, { updateUrl: false });
  }

  /* ---------------- Sticky bar ---------------- */
  function initSticky(root) {
    var bar = qs(root, '[data-pdp-sticky]');
    var anchor = qs(root, '[data-pdp-cta]');
    if (!bar || !anchor || !('IntersectionObserver' in window)) return;
    function setShown(show) {
      bar.classList.toggle('show', show);
      if (show) { bar.removeAttribute('inert'); bar.setAttribute('aria-hidden', 'false'); }
      else { bar.setAttribute('inert', ''); bar.setAttribute('aria-hidden', 'true'); }
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        setShown(!entry.isIntersecting && entry.boundingClientRect.top < 0);
      });
    }, { threshold: 0 });
    io.observe(anchor);
  }

  /* ---------------- Policy popup ---------------- */
  function initPolicy(root) {
    var modal = qs(root, '[data-pdp-policy-modal]');
    var trigger = qs(root, '[data-pdp-policy-open]');
    if (!modal || !trigger) return;
    var closeBtn = qs(modal, '.pdp-policy-x');
    function open() {
      modal.removeAttribute('inert');
      modal.setAttribute('aria-hidden', 'false');
      modal.classList.add('open');
      if (closeBtn) closeBtn.focus();
    }
    function close() {
      if (!modal.classList.contains('open')) return;
      modal.classList.remove('open');
      modal.setAttribute('aria-hidden', 'true');
      modal.setAttribute('inert', '');
      trigger.focus();
    }
    trigger.addEventListener('click', function (e) { e.preventDefault(); open(); });
    qsa(modal, '[data-pdp-policy-close]').forEach(function (el) { el.addEventListener('click', close); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });
  }

  function initProduct(root) {
    if (root.dataset.pdpBound) return;
    root.dataset.pdpBound = '1';
    var gallery = initGallery(root);
    initVariants(root, gallery);
    initSticky(root);
    initPolicy(root);
  }

  /* ---------------- Cross-sell ---------------- */
  function initCrossSell(root) {
    if (root.dataset.xsellBound) return;
    root.dataset.xsellBound = '1';
    var errorLabel = root.dataset.labelError || 'Could not add';
    qsa(root, '[data-xsell-add]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var id = btn.dataset.variantId;
        if (!id) return;
        if (!hasCart()) {
          window.location.href = '/cart/add?id=' + encodeURIComponent(id) + '&quantity=1';
          return;
        }
        var original = btn.textContent;
        btn.disabled = true;
        btn.setAttribute('aria-busy', 'true');
        window.SixFtCart.addVariant(id, 1)
          .then(function () {
            btn.disabled = false;
            btn.removeAttribute('aria-busy');
            openCart();
          })
          .catch(function () {
            btn.removeAttribute('aria-busy');
            btn.textContent = errorLabel;
            setTimeout(function () {
              btn.textContent = original;
              btn.disabled = false;
            }, TOAST_MS);
          });
      });
    });
  }

  function initAll(scope) {
    qsa(scope, '[data-pdp]').forEach(initProduct);
    qsa(scope, '[data-xsell]').forEach(initCrossSell);
  }

  window.SixFtPDP = { init: initAll };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  } else {
    initAll(document);
  }
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();
